import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { PreactView } from 'common/module/preact/view';
import { MyAccountStatechartService } from 'common/service/my-account-statechart/service';
import { MyAccountHeaderTemplate } from 'desktop/module/my-account/header/template';
import { MyAccountHeaderViewStoreFactory } from 'desktop/module/my-account/header/view-store.factory';

import { MyAccountViewStrategy } from './strategy';

export function MyAccountViewStrategyFactory(): MyAccountViewStrategy {
  return new MyAccountViewStrategy(
    new PreactView(MyAccountHeaderTemplate, MyAccountHeaderViewStoreFactory()),
    EventEmitterFactory(),
    MyAccountStatechartService()
  );
}
